import styled from "styled-components";

import {
  DefaultTitleXLargeFactory,
  DefaultTitleSmallFactory,
  DefaultParagraphLargeFactory,
  DefaultParagraphMediumFactory,
} from "components/common/Typograph/Typograph.Style";

export const SectionCorporativeGovernanceContainer = styled.section(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "32px",

    paddingTop: "40px",
    paddingBottom: "20px",

    [theme.breakpoint.lg()]: {
      gap: "60px",
      paddingTop: "60px",
      paddingBottom: "30px",
    },
  }),
);

export const SectionCorporativeGovernanceTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleXLargeFactory({ theme }),
  color: theme.color.brandPrimary.light,
  fontWeight: "700",
  margin: 0,
}));

export const SectionCorporativeGovernanceContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    gap: "60px",
    flexDirection: "row",
  },
}));

export const SectionCorporativeGovernanceDescription = styled.div(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    flex: 1,

    [theme.breakpoint.lg()]: {
      gap: "32px",
    },

    p: {
      ...DefaultParagraphLargeFactory({ theme }),
      fontWeight: "500",
      lineHeight: "160%",
      margin: 0,
      padding: 0,
    },
  }),
);

export const SectionCorporativeGovernanceProfile = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  maxWidth: "100%",

  [theme.breakpoint.lg()]: {
    maxWidth: "199px",
    width: "100%",
  },

  img: {
    width: "100%",
    height: "auto",
  },
}));

export const SectionCorporativeGovernanceProfileContent = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const SectionCorporativeGovernanceProfileTitle = styled.h2(
  ({ theme }) => ({
    ...DefaultTitleSmallFactory({ theme }),
    color: theme.color.brandPrimary.light,
    fontWeight: "700",
    margin: 0,
  }),
);

export const SectionCorporativeGovernanceProfileDescription = styled.p(
  ({ theme }) => ({
    ...DefaultParagraphMediumFactory({ theme }),
    fontWeight: 500,
    margin: 0,
  }),
);
